import React, { ComponentType } from 'react';
import { ForgeList } from '@tylertech/forge-react';

import type { View } from 'common/types/view';
import type { GuidanceSummaryV2 } from 'common/types/approvals';

import { I18n } from 'common/i18n';

import { ManageViewersActionItem } from './action_items/ManageViewersActionItem';
import { EditMetadataActionItem } from './action_items/EditMetadataActionItem';
import { ManageCollaboratorsActionItem } from './action_items/ManageCollaboratorsActionItem';
import { TransferOwnershipActionItem } from './action_items/TransferOwnershipActionItem';
import { DeleteAssetActionItem } from './action_items/DeleteAssetActionItem';
import { LockAssetActionItem } from './action_items/LockAssetActionItem';
import { WithdrawFromApprovalActionItem } from './action_items/WithdrawFromApprovalActionItem';
import { ToggleCatalogVisibility } from './action_items/ToggleCatalogVisibility';
import { GoToSourceActionItem } from './action_items/GoToSourceActionItem';
import { ManageFederationsActionItem } from './action_items/ManageFederationsActionItem';

export interface ActionItemListProps {
  approvalsGuidance: GuidanceSummaryV2 | null;
  assetIsStoryDraft?: boolean;
  assetType: string | undefined;
  closeCurrentModal: () => void;
  link: string;
  setCurrentModal: (modal: ComponentType<any>, props: any) => void;
  /* null means asset is not a revision */
  revisionInfo?: { revisionSeq: number; link: string } | null;
  updateAudience?: (payload: any) => void;
  updateView?: () => void;
  transferOwnership?: (payload: any) => void;
  view?: View;
  isCatalogFederatedView?: boolean;
  isDataFederatedView?: boolean;
  sourceLink?: string;
}

export const ActionItemList = (props: ActionItemListProps) => {
  const actionItems: ComponentType<any>[] = [
    GoToSourceActionItem,
    EditMetadataActionItem,
    ManageViewersActionItem,
    ManageCollaboratorsActionItem,
    ManageFederationsActionItem,
    ToggleCatalogVisibility,
    TransferOwnershipActionItem,
    LockAssetActionItem,
    DeleteAssetActionItem,
    WithdrawFromApprovalActionItem,
  ];

  // TODO: The above list is never actually filtered, so this is never true
  if (actionItems.length === 0) {
    return (
      <div className="no-actions-possible">
        {I18n.t('shared.asset_browser.result_list_table.action_dropdown.no_actions_possible')}
      </div>
    );
  }

  return (
    <ForgeList className="forge-action-dropdown-menu">
      {actionItems.map((ActionItemComponent) => (
        <ActionItemComponent key={`${ActionItemComponent}`} {...props} />
      ))}
    </ForgeList>
  );
};
